// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 29) return "static/js/b7133edf19848e08a962.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"30a8d116ac46052e039f","148":"f56907702411c0160d22","149":"3c5a1a9e635d21f3cb3b"}[chunkId] + ".chunk.js";
};